
define('text!templates/widgets/popoverContents.html',[],function () { return '<div class="popover-container" data-bind="\n      include: $data\n"></div>';});

